import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 20px;\n  height: calc(100% - 60px);\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  height: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AdBannerEmpty, useAdBannerQuery } from "@/components/Banner/AdBanner";
import { SideSheetSteps } from "@/components/SideSheets/GNBSideSheet";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { EBOOKS_LANDING, EBOOKS_UNIVERSITY_LANDING } from "@/settings/constant";
import { Box as MuiBox, Typography } from "@mui/material";
import Link from "next/link";
import { useCallback } from "react";
import styled from "styled-components";
import { MenuListContainer, SideSheetContentsContainer, SideSheetHeader, SideSheetUtils, StepDivider } from ".";
import { AdBanner } from "../Banner/AdBanner/AdBanner";
import { MenuColumn } from "../Category";
import useCategorySideDepth from "../Category/hooks/useCategorySideDepth";
import { Box, BoxContainer, BoxTitle, ButtonBox, MenuLinkBox, RowContainer } from "../Category/index.style";
import Icon from "../icon/Icon";
import { ArrowRight, GoodnoteIcon, Sizes } from "../icon/IconList";
import { useSideCategoryMenuStore } from "./store/useCategoryMenuStore";
//SideSheetSteps.default
export const SideSheetDefaultStep = (param)=>{
    let { goToNextStep , onClose  } = param;
    var _depthData_origin, _depthData_two;
    const { currentOneDepth , depthData  } = useCategorySideDepth();
    const { setState  } = useSideCategoryMenuStore((state)=>({
            setState: state.setState
        }));
    const onClickMenu = useCallback((menuId)=>{
        setState("twoDepthId", menuId);
        goToNextStep(SideSheetSteps.menuList);
    }, [
        setState,
        goToNextStep
    ]);
    const categoryMenuMixpanel = (depth, title, url)=>{
        mixpanelEvent("Category Menu Clicked", {
            Depth: depth,
            "Menu Name": title,
            Url: url
        });
    };
    const categoryButtonMixpanel = (type, name, url)=>{
        mixpanelEvent("Category Button Clicked", {
            "Button Type": type,
            "Menu Name": name,
            Url: url
        });
    };
    return /*#__PURE__*/ _jsx(SideSheetContentsContainer, {
        children: /*#__PURE__*/ _jsxs(SideSheetContent, {
            children: [
                /*#__PURE__*/ _jsx(SideSheetHeader, {
                    title: "메뉴",
                    onClose: onClose,
                    currentStep: SideSheetSteps.default
                }),
                /*#__PURE__*/ _jsx(SideSheetUtils, {}),
                /*#__PURE__*/ _jsx(AdBanner, {
                    position: "moSide",
                    shape: "fullWidth",
                    mixpanelPosition: "side sheets"
                }),
                depthData && /*#__PURE__*/ _jsx(MenuListContainer, {
                    children: /*#__PURE__*/ _jsxs(ColumnBox, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuLinkBox, {
                                className: "link-box-mobile",
                                children: /*#__PURE__*/ _jsxs(RowContainer, {
                                    className: "container-mobile",
                                    children: [
                                        /*#__PURE__*/ _jsx(BoxContainer, {
                                            children: (_depthData_origin = depthData.origin) === null || _depthData_origin === void 0 ? void 0 : _depthData_origin.depthItems.map((menu)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                                    data: menu,
                                                    onColumnClick: ()=>{
                                                        setState("currentDepth", menu.id);
                                                        categoryMenuMixpanel("one", menu.name, "");
                                                    },
                                                    isActive: currentOneDepth === menu.id
                                                }, menu.id))
                                        }),
                                        /*#__PURE__*/ _jsxs(Box, {
                                            children: [
                                                /*#__PURE__*/ _jsxs(ButtonBox, {
                                                    className: "active",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Typography, {
                                                            variant: "subtitle2",
                                                            sx: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: "4px",
                                                                alignItems: "center",
                                                                marginBottom: "8px",
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Icon, {
                                                                    icon: GoodnoteIcon,
                                                                    size: Sizes.small
                                                                }),
                                                                "굿노트6 eBook"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(Link, {
                                                            href: EBOOKS_UNIVERSITY_LANDING,
                                                            onClick: ()=>categoryButtonMixpanel("goodnotes", "대학교재", EBOOKS_UNIVERSITY_LANDING),
                                                            children: /*#__PURE__*/ _jsx("button", {
                                                                children: "대학 교재"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(ButtonBox, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: EBOOKS_LANDING,
                                                        onClick: ()=>categoryButtonMixpanel("goodnotes", "중고등 교재", EBOOKS_LANDING),
                                                        children: /*#__PURE__*/ _jsx("button", {
                                                            children: "중고등 교재"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            depthData.two && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                                children: [
                                    /*#__PURE__*/ _jsx(BoxTitle, {
                                        children: ((_depthData_two = depthData.two) === null || _depthData_two === void 0 ? void 0 : _depthData_two.name) || ""
                                    }),
                                    /*#__PURE__*/ _jsx(RowContainer, {
                                        className: "depth-one-container",
                                        children: /*#__PURE__*/ _jsx(BoxContainer, {
                                            children: depthData.two.items.map((menu, idx)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                                    data: menu,
                                                    onColumnClick: ()=>{
                                                        onClickMenu(menu.id);
                                                        categoryMenuMixpanel("two", menu.name, "");
                                                    },
                                                    isActive: false,
                                                    suffix: true
                                                }, menu.id))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
//SideSheetSteps.menuList
export const SideSheetMenuListStep = (param)=>{
    let { goToPrevStep , onClose  } = param;
    var _depthData_two, _depthData_three, _depthData_four, _depthData_four1;
    const { depthData  } = useCategorySideDepth();
    const { threeDepthIdInStore , setState  } = useSideCategoryMenuStore((state)=>({
            threeDepthIdInStore: state.threeDepthId,
            setState: state.setState,
            closeSideMenu: state.closeSideMenu
        }));
    const categoryMenuMixpanel = (depth, title, url)=>{
        mixpanelEvent("Category Menu Clicked", {
            Depth: depth,
            "Menu Name": title,
            Url: url
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SideSheetHeader, {
                title: "".concat((_depthData_two = depthData.two) === null || _depthData_two === void 0 ? void 0 : _depthData_two.name, " - ").concat(depthData.three.name) || "",
                onClose: onClose,
                currentStep: SideSheetSteps.menuList,
                goToPrevStep: goToPrevStep
            }),
            /*#__PURE__*/ _jsx(StepDivider, {}),
            /*#__PURE__*/ _jsx(MenuListContainer, {
                className: "depth-two-container",
                children: /*#__PURE__*/ _jsxs(ColumnBox, {
                    children: [
                        /*#__PURE__*/ _jsx(MenuLinkBox, {
                            className: "link-box-mobile _depth-two",
                            children: /*#__PURE__*/ _jsx(RowContainer, {
                                className: "container-mobile",
                                children: /*#__PURE__*/ _jsx(BoxContainer, {
                                    children: (_depthData_three = depthData.three) === null || _depthData_three === void 0 ? void 0 : _depthData_three.items.map((item)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                            data: item,
                                            onColumnClick: ()=>{
                                                setState("threeDepthId", item.id);
                                                categoryMenuMixpanel("three", item.name, "");
                                            },
                                            isActive: item.id === threeDepthIdInStore
                                        }, item.id))
                                })
                            })
                        }),
                        depthData && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/categories?id=".concat((_depthData_four = depthData.four) === null || _depthData_four === void 0 ? void 0 : _depthData_four.id),
                                    children: /*#__PURE__*/ _jsx(BoxTitle, {
                                        children: /*#__PURE__*/ _jsxs(MuiBox, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px"
                                            },
                                            children: [
                                                ((_depthData_four1 = depthData.four) === null || _depthData_four1 === void 0 ? void 0 : _depthData_four1.name) || "",
                                                /*#__PURE__*/ _jsx(Icon, {
                                                    icon: ArrowRight,
                                                    size: Sizes.small
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(RowContainer, {
                                    className: "depth-two-row-container",
                                    children: /*#__PURE__*/ _jsx(BoxContainer, {
                                        children: depthData.four && depthData.four.items.map((menu)=>/*#__PURE__*/ _jsx(Link, {
                                                href: "/categories?id=".concat(menu.id),
                                                children: /*#__PURE__*/ _jsx(MenuColumn, {
                                                    data: menu,
                                                    onColumnClick: ()=>{
                                                        categoryMenuMixpanel("four", menu.name, "/categories?id=".concat(menu.id));
                                                    },
                                                    isActive: false,
                                                    suffix: true
                                                }, menu.id)
                                            }, menu.id))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
//SideSheetSteps.adList
export const SideSheetAdListStep = (param)=>{
    let { goToPrevStep , onClose  } = param;
    const { noAdItems  } = useAdBannerQuery({
        position: "globalMenu",
        subject: null
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SideSheetHeader, {
                title: "쏠북 소식",
                onClose: onClose,
                currentStep: SideSheetSteps.adList,
                goToPrevStep: goToPrevStep
            }),
            /*#__PURE__*/ _jsx(StepDivider, {}),
            /*#__PURE__*/ _jsx(SideSheetAdListContainer, {
                children: noAdItems ? /*#__PURE__*/ _jsx(AdBannerEmpty, {}) : /*#__PURE__*/ _jsx(AdBanner, {
                    position: "globalMenu",
                    mixpanelPosition: "side sheets"
                })
            })
        ]
    });
};
const SideSheetAdListContainer = styled.div.withConfig({
    componentId: "sc-79fbdc89-0"
})(_templateObject());
export const ColumnBox = styled.div.withConfig({
    componentId: "sc-79fbdc89-1"
})(_templateObject1());
const SideSheetContent = styled.div.withConfig({
    componentId: "sc-79fbdc89-2"
})(_templateObject2());
